module.exports = __webpack_public_path__ + "static/engineering-d8076c75410235af2b3adf6260cd8633.svg";